import React from 'react';
import styles from '@/css/module/new-world.css';
import flex from '@/css/module/flex.css';
import AjaxSpinner from '@/components/AjaxSpinner';

export const LoadingSpinner = () => (
  <div className={styles.main}>
    <div className={flex.middle}>
      <AjaxSpinner />
    </div>
  </div>
);
